<mat-button-toggle-group
  y42StopPropagation
  class="toggle-group-deep-style"
  [value]="state.isOn"
  [disabled]="state.isDisabled"
  (change)="setState($event)"
>
  <mat-button-toggle [value]="false">OFF</mat-button-toggle>
  <mat-button-toggle [value]="true">ON</mat-button-toggle>
</mat-button-toggle-group>
